import SvgIcon from '@mui/material/SvgIcon';

export default function ArchiveFilledIcon(props) {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M17.6933 7.48667L16.7667 6.36667C16.5867 6.14 16.3133 6 16 6H8C7.68667 6 7.41333 6.14 7.22667 6.36667L6.30667 7.48667C6.11333 7.71333 6 8.01333 6 8.33333V16.6667C6 17.4 6.6 18 7.33333 18H16.6667C17.4 18 18 17.4 18 16.6667V8.33333C18 8.01333 17.8867 7.71333 17.6933 7.48667ZM11.7667 15.4333L8.33333 12H10.6667V10.6667H13.3333V12H15.6667L12.2333 15.4333C12.1067 15.56 11.8933 15.56 11.7667 15.4333V15.4333ZM7.41333 7.33333L7.95333 6.66667H15.9533L16.58 7.33333H7.41333Z" />
    </SvgIcon>
  );
}
